import React, { useState } from "react";

import styled from "styled-components";

import useIntersect from "hooks/useIntersect";

export interface Props {
  alt: string;
  src: string | undefined;
  lazy?: boolean;
  onClick?: () => void;
}

export const ImgStyle = styled.img`
  width: inherit;
  height: inherit;
  object-fit: inherit;
  box-sizing: border-box;
`;

function Img({ alt, src, lazy = true }: Props): React.ReactElement {
  const [imgSrc, setImage] = useState(lazy ? "" : src);
  const [, setRef] = useIntersect(
    async (
      entry: IntersectionObserverEntry,
      observer: IntersectionObserver
    ) => {
      setImage(src);
      observer.unobserve(entry.target);
    },
    {
      rootMargin: "0% 0% 33% 0%",
      threshold: 0.5,
    }
  );

  return <ImgStyle alt={alt} src={imgSrc} ref={lazy ? setRef : null} />;
}

export default Img;
